(() => {
  const feedSelector = '#feed-48312';
  const subtitleClass = 'instafeed-subtitle';
  const subtitleHtml =
    'See Photos of how our customer styled their home with COLAMY Furniture, tag <em>@colamyhomeofficial</em>';

  function applyStyles(feed) {
    if (document.getElementById('instafeed-living-room-styles')) return;

    const styles = document.createElement('style');
    styles.id = 'instafeed-living-room-styles';
    styles.textContent = `
      ${feedSelector} h1,
      ${feedSelector} h2,
      ${feedSelector} h3,
      ${feedSelector} .h3,
      ${feedSelector} .section-title {
        font-size: 32px !important;
        font-weight: 400 !important;
        color: #1c1c1c;
        letter-spacing: -1px;
      }

      ${feedSelector} .${subtitleClass} {
        display: block !important;
        margin: -20px 0 25px;
        color: #1c1c1c;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
      }
    `;
    document.head.appendChild(styles);
  }

  let feedObserver;

  function addSubtitle() {
    const feed = document.querySelector(feedSelector);
    if (!feed) return;

    applyStyles(feed);

    if (!feedObserver) {
      observer.disconnect();
      feedObserver = new MutationObserver(addSubtitle);
      feedObserver.observe(feed, { childList: true, subtree: true });
    }

    const title = feed.querySelector('h2, h3, .h3, .section-title, h1');
    if (!title || feed.querySelector(`.${subtitleClass}`)) return;

    const subtitle = document.createElement('p');
    subtitle.className = subtitleClass;
    subtitle.innerHTML = subtitleHtml;
    title.insertAdjacentElement('afterend', subtitle);
  }

  const observer = new MutationObserver(addSubtitle);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  addSubtitle();
})();
